import { Barcode, Boxes, Building2, Layers, Ruler, Store, Truck, UserSquare } from 'lucide-react';

import { defineArea } from '../../app/area';
import { UnderConstruction } from '../../components/UnderConstruction';
import { ArticleDetailPage } from './pages/ArticleDetailPage';
import { ArticlesPage } from './pages/ArticlesPage';
import { BarcodesPage } from './pages/BarcodesPage';
import { CategoriesPage } from './pages/CategoriesPage';
import { RestaurantDetailPage, RestaurantsPage } from './pages/RestaurantsPage';
import { RestaurantUsersPage } from './pages/RestaurantUsersPage';
import { SupplierDetailPage, SuppliersPage } from './pages/SuppliersPage';
import { UnitsPage } from './pages/UnitsPage';

/**
 * OWNER: the `master-data` module agent (M1 — docs/MODULES.md).
 * Owns: apps/web/src/areas/master-data/**  ·  apps/api/src/modules/master-data/**
 *       packages/shared/src/contracts/master-data.ts
 *       packages/shared/src/i18n/{sv,en,zh}/masterData.json  ·  e2e/master-data.md
 *
 * `registers/users` stays an `UnderConstruction` placeholder on purpose: the
 * users register is EMS-provisioned identity (`admin.users`), not master data,
 * and belongs to whoever builds the admin area. Its nav slot lives here only
 * because the scaffold grouped it under Register.
 */
export default defineArea({
  id: 'master-data',
  nav: [
    {
      section: 'registers',
      to: '/registers/articles',
      labelKey: 'common:nav.masterData.articles',
      icon: Boxes,
      permissions: ['registers.articles.read'],
      order: 10,
    },
    {
      section: 'registers',
      to: '/registers/categories',
      labelKey: 'common:nav.masterData.categories',
      icon: Layers,
      permissions: ['registers.articles.categories'],
      order: 20,
    },
    {
      section: 'registers',
      to: '/registers/units',
      labelKey: 'common:nav.masterData.units',
      icon: Ruler,
      permissions: ['registers.articles.units'],
      order: 30,
    },
    {
      section: 'registers',
      to: '/registers/barcodes',
      labelKey: 'common:nav.masterData.barcodes',
      icon: Barcode,
      permissions: ['registers.barcodes.manage'],
      order: 40,
    },
    {
      section: 'registers',
      to: '/registers/suppliers',
      labelKey: 'common:nav.masterData.suppliers',
      icon: Truck,
      permissions: ['registers.suppliers.read'],
      order: 50,
    },
    {
      section: 'registers',
      to: '/registers/restaurants',
      labelKey: 'common:nav.masterData.restaurants',
      icon: Store,
      permissions: ['registers.restaurants.read'],
      order: 60,
    },
    {
      section: 'registers',
      to: '/registers/restaurant-users',
      labelKey: 'common:nav.masterData.restaurantUsers',
      icon: UserSquare,
      permissions: ['registers.restaurantUsers.manage'],
      order: 70,
    },
    {
      section: 'registers',
      to: '/registers/users',
      labelKey: 'common:nav.admin.users',
      icon: Building2,
      permissions: ['admin.users'],
      order: 80,
    },
  ],
  routes: [
    { path: 'registers/articles', element: <ArticlesPage /> },
    { path: 'registers/articles/:id', element: <ArticleDetailPage /> },
    { path: 'registers/categories', element: <CategoriesPage /> },
    { path: 'registers/units', element: <UnitsPage /> },
    { path: 'registers/barcodes', element: <BarcodesPage /> },
    { path: 'registers/suppliers', element: <SuppliersPage /> },
    { path: 'registers/suppliers/:id', element: <SupplierDetailPage /> },
    { path: 'registers/restaurants', element: <RestaurantsPage /> },
    { path: 'registers/restaurants/:id', element: <RestaurantDetailPage /> },
    { path: 'registers/restaurant-users', element: <RestaurantUsersPage /> },
    { path: 'registers/users', element: <UnderConstruction titleKey="common:nav.admin.users" /> },
  ],
});
